// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./CheckIcon.data";

export const CheckIcon = createIcon("CheckIcon", iconNode);
